// extracted by mini-css-extract-plugin
export default {"title":"section-title-module--title--Zsday"};